import React from 'react';
import { saveAs } from 'file-saver';
import { Tooltip, useTheme } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { StyledMapButton, iconStyle } from './materialTheme/StyledMapComponents';

const DownloadObservationButton = ({ dataSource, type }) => {
  const theme = useTheme();

  const convertToGeoJSON = (data) => ({
    type: 'FeatureCollection',
    features: Array.isArray(data)
      ? data.map((observation) => ({
          type: 'Feature',
          id: observation.id,
          properties: { ...observation.properties, delta: observation.delta },
          geometry: observation.geometry,
        }))
      : [
          {
            geometry: data.geometry,
          },
        ],
  });

  const handleDownload = () => {
    const dataToDownload = convertToGeoJSON(dataSource);
    const fileContent = JSON.stringify(dataToDownload, null, 2);
    let fileName;
    const date = new Date().toLocaleDateString();
    switch (type) {
      case 'all':
        fileName = `LEAK_${dataSource[0].properties.leak_info.identifier}_DATE_${date}.geojson`;
        break;
      case 'one':
        fileName = `OBS_${dataSource.properties.identifier}_DATE_${date}.geojson`;
        break;
      default:
        break;
    }
    const blob = new Blob([fileContent], { type: 'application/json' });
    saveAs(blob, fileName);
  };

  let IconComponent;
  let buttonStyles;
  switch (type) {
    case 'all':
      IconComponent = DownloadIcon;
      buttonStyles = {
        background: 'none',
        boxShadow: 'none',
        marginLeft: '0px',
        '&:hover': {
          background: 'none',
          boxShadow: 'none',
        },
      };
      break;
    case 'one':
      IconComponent = SaveAltIcon;
      buttonStyles = {
        background: theme.palette.primary.main,
        zIndex: 1002,
        '&:hover': {
          background: theme.palette.primary.buttonSelected,
        },
      };
      break;
    default:
      IconComponent = DownloadIcon;
      buttonStyles = {
        background: theme.palette.primary.main,
        '&:hover': {
          background: theme.palette.primary.buttonMain,
        },
      };
  }

  return (
    <Tooltip title={`Download Observation Data (${type})`}>
      <StyledMapButton
        variant="contained"
        color="primary"
        onClick={handleDownload}
        startIcon={<IconComponent sx={iconStyle({ theme, isActive: false })} />}
        sx={buttonStyles}
      />
    </Tooltip>
  );
};

export default DownloadObservationButton;